module.exports = __webpack_public_path__ + "static/assets/1bb8b9cd92481b1326d5aee248e5851a.svg";